import { useEffect, useState, useMemo } from "react";
import ProfileList from "../../../Components/ProfileList/ProfileList";
import { generateFilteredPDF } from "../../../utils/generateFilteredPDF";
import { FiDownload } from "react-icons/fi";
import Strings from "../../../utils/Strings";
import configuration from "../../../Config/configuration";
import MessageBar, {
  config,
  errorNotify,
  getValueFromLocalStorage,
  localStorageKey,
} from "../../../utils/helper";
import { authorizedGet } from "../../../Config/networkWithToken";
import Spinner from "../../../Components/Spinner/Spinner";
import Filter from "../Filter/Filter";
import Pagination from "../../../Components/Pagination/Pagination";
import { ItemsPerPages } from "../../../utils/data";
import AdvanceSearch from "../../../Components/AdvanceSearch/AdvancedSearchMatrimony";
import { ImCancelCircle } from "react-icons/im";
import { IoIosSearch } from "react-icons/io";
import { useLocation } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { useMatrimonyUsers, USERS_QUERY_KEY } from "./useMatrimonyUsers";

const Matrimony = () => {
  const [activeTab, setActiveTab] = useState(
    parseInt(localStorage.getItem("activeTab")) || 0,
  );
  const [maleList, setMaleList] = useState([]);
  const [femaleList, setFemaleList] = useState([]);
  const [allUserList, setAllUserList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [noResultsMessage, setNoResultsMessage] = useState("");
  const [showTabs, setShowTabs] = useState(true);
  const [noMaleUsersMessage, setNoMaleUsersMessage] = useState("");
  const [noFemaleUsersMessage, setNoFemaleUsersMessage] = useState("");
  const [Role, setRole] = useState(null);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const currentPage = Number(searchParams.get("page")) || 1;
  const [currentPageAll, setCurrentPageAll] = useState(currentPage);
  const [currentPageMale, setCurrentPageMale] = useState(currentPage);
  const [currentPageFemale, setCurrentPageFemale] = useState(currentPage);
  const [currentFilterPage, setCurrentFilterPage] = useState(currentPage);
  const [currentSearchPage, setCurrentSearchPage] = useState(currentPage);
  const [isSearchBarVisible, setIsSearchBarVisible] = useState(false);
  const [searchUserList, setSearchUserlist] = useState([]);
  const [mainActiveTab, setMainActiveTab] = useState(
    parseInt(localStorage.getItem("mainActiveTab")) || 0,
  );
  const [sortOrder, SetSortOrder] = useState(
    localStorage.getItem("sortOrder") || "last",
  );
  const [allTabUsers, setAllTabUsers] = useState([]);

  const isFilterApplied = localStorage.getItem("isFiltered");
  const itemsPerPage = ItemsPerPages;
  const queryClient = useQueryClient();

  const {
    data: rawUsers = [],
    isLoading: initialLoading,
    isFetching,
  } = useMatrimonyUsers();

  useEffect(() => {
    const needsRefetch = sessionStorage.getItem("matrimonyNeedsRefetch");
    if (needsRefetch === "true") {
      sessionStorage.removeItem("matrimonyNeedsRefetch");
      queryClient.refetchQueries({ queryKey: USERS_QUERY_KEY });
    }
  }, []);
  const allUsers = rawUsers;

const handleFilterByStatus = (data) => {
  if (!data) return [];
  return data.filter((user) =>
    user.profileCompleted === true && user.isActive !== false
  );
};

const handleFilterByRegisteredUsers = (data) => {
  if (!data) return [];
  return data.filter((user) => {
    if (user.isActive === false && user.profileCompletionPercentage > 0) return true;
    if (user.profileCompletionPercentage > 0 && user.profileCompleted !== true && user.isActive !== false) return true;
    return false;
  });
};

const handleFilterBySignupUsers = (data) => {
  if (!data) return [];
  return data.filter((user) => user.profileCompletionPercentage === 0);
};

  const filterByGender = (data, gender) => {
    if (!data) return [];
    if (gender) return data.filter((user) => user.gender === gender);
    return data;
  };

  const activeUsers = useMemo(() => handleFilterByStatus(rawUsers), [rawUsers]);
  const registerUsers = useMemo(
    () => handleFilterByRegisteredUsers(rawUsers),
    [rawUsers],
  );
  const signupUsers = useMemo(
    () => handleFilterBySignupUsers(rawUsers),
    [rawUsers],
  );

  const sortUsers = (users, order) => {
    let sorted = [...users];
    if (order === "last") {
      sorted.sort(
        (a, b) =>
          new Date(b.updatedAt || b.registerDate) -
          new Date(a.updatedAt || a.registerDate),
      );
    } else if (order === "asc") {
      sorted.sort(
        (a, b) => new Date(a.registerDate) - new Date(b.registerDate),
      );
    } else if (order === "desc") {
      sorted.sort(
        (a, b) => new Date(b.registerDate) - new Date(a.registerDate),
      );
    }
    return sorted;
  };

  useEffect(() => {
    const isFilterApplied = JSON.parse(localStorage.getItem("isFiltered"));
    const storedFilteredData = JSON.parse(localStorage.getItem("filteredData"));
    const storedSearchResults = JSON.parse(
      localStorage.getItem("searchResults"),
    );
    if (storedSearchResults) {
      setSearchUserlist(storedSearchResults);
    } else if (isFilterApplied && storedFilteredData) {
      setFilteredData(storedFilteredData);
    }
    fetchRole();
  }, []);

  useEffect(() => {
    localStorage.setItem("mainActiveTab", mainActiveTab);
    localStorage.setItem("activeTab", activeTab);

    let selectedUsers =
      mainActiveTab === 1
        ? handleFilterByStatus(allUsers)
        : mainActiveTab === 2
          ? handleFilterByRegisteredUsers(allUsers)
          : mainActiveTab === 3
            ? handleFilterBySignupUsers(allUsers)
            : allUsers;

    const storedSortOrder = localStorage.getItem("sortOrder") || "last";
    SetSortOrder(storedSortOrder);

    let sortedUsers = sortUsers(selectedUsers, storedSortOrder);

    if (JSON.stringify(sortedUsers) !== JSON.stringify(allUserList)) {
      setAllUserList(sortedUsers);
    }
    if (activeTab === 1) {
      const filteredMales = filterByGender(sortedUsers, "male");
      if (JSON.stringify(filteredMales) !== JSON.stringify(maleList)) {
        setMaleList(filteredMales);
      }
    } else if (activeTab === 2) {
      const filteredFemales = filterByGender(sortedUsers, "female");
      if (JSON.stringify(filteredFemales) !== JSON.stringify(femaleList)) {
        setFemaleList(filteredFemales);
      }
    }
  }, [mainActiveTab, activeTab, allUsers]);

  const fetchRole = async () => {
    const role = getValueFromLocalStorage(localStorageKey.USERDATA, "role");
    if (role) setRole(role);
  };

  const mainTabList = [
    { name: "All Users", count: allUsers.length },
    { name: "Active Users", count: activeUsers.length },
    { name: "Registered Users", count: registerUsers.length },
    { name: "Signup Users", count: signupUsers.length },
  ];

  const tabList = [
    {
      name: "Users",
      count: mainActiveTab === 0 ? allUsers.length : allTabUsers.length,
    },
    { name: "Male", count: maleList.length },
    { name: "Female", count: femaleList.length },
  ];

  const handleTabClick = (index) => {
    setActiveTab(index);
    setShowTabs(true);
    setCurrentPageAll(1);
    setCurrentPageFemale(1);
    setCurrentPageMale(1);

    let selectedUsers =
      mainActiveTab === 1
        ? handleFilterByStatus(allUsers)
        : mainActiveTab === 2
          ? handleFilterByRegisteredUsers(allUsers)
          : mainActiveTab === 3
            ? handleFilterBySignupUsers(allUsers)
            : allUsers;

    if (index === 1) setMaleList(filterByGender(selectedUsers, "male"));
    else if (index === 2)
      setFemaleList(filterByGender(selectedUsers, "female"));
  };

  const handleMainTabClick = (index) => {
    setMainActiveTab(index);
    setActiveTab(0);
    setMaleList([]);
    setFemaleList([]);
    setShowTabs(true);
    setCurrentPageAll(1);
    setCurrentPageFemale(1);
    setCurrentPageMale(1);
    SetSortOrder("last");

    let selectedUsers =
      index === 1
        ? handleFilterByStatus(allUsers)
        : index === 2
          ? handleFilterByRegisteredUsers(allUsers)
          : index === 3
            ? handleFilterBySignupUsers(allUsers)
            : allUsers;

    setAllUserList(selectedUsers);
    setMaleList(filterByGender(selectedUsers, "male"));
    setFemaleList(filterByGender(selectedUsers, "female"));
  };

  const handleSort = (value) => {
    SetSortOrder(value);
    localStorage.setItem("sortOrder", value);
    const sortedList = sortUsers(allUserList, value);
    setAllUserList(sortedList);
    if (activeTab === 1) setMaleList(filterByGender(sortedList, "male"));
    else if (activeTab === 2)
      setFemaleList(filterByGender(sortedList, "female"));
  };

  const handleApplyFilters = async (queryParams) => {
    try {
      setLoading(true);
      setCurrentFilterPage(1);
      let res = "";

      if (activeTab === 0) {
        if (mainActiveTab === 0)
          res = await authorizedGet(
            `${configuration.apis.filter}?${queryParams}`,
            config,
          );
        else if (mainActiveTab === 1)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=Active&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 2)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=register&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 3)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=signup&${queryParams}`,
            config,
          );
      } else if (activeTab === 1) {
        if (mainActiveTab === 0)
          res = await authorizedGet(
            `${configuration.apis.filter}?gender=male&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 1)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=Active&gender=male&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 2)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=register&gender=male&${queryParams}`,
            config,
          );
      } else if (activeTab === 2) {
        if (mainActiveTab === 0)
          res = await authorizedGet(
            `${configuration.apis.filter}?gender=female&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 1)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=Active&gender=female&${queryParams}`,
            config,
          );
        else if (mainActiveTab === 2)
          res = await authorizedGet(
            `${configuration.apis.filter}?status=register&gender=female&${queryParams}`,
            config,
          );
      }

      const response = res?.data;
      if (response?.status) {
        setFilteredData(response?.data);
        localStorage.setItem("isFiltered", JSON.stringify(true));
        localStorage.setItem("filteredData", JSON.stringify(response?.data));
        setNoResultsMessage("");
      } else {
        setNoResultsMessage("No users found matching your criteria.");
      }
    } catch (error) {
      errorNotify(Strings.ERROR);
    }
    setLoading(false);
  };

  const handleClearFilter = () => {
    setLoading(true);
    setCurrentFilterPage(1);
    setCurrentSearchPage(1);
    setCurrentPageAll(1);
    setCurrentPageMale(1);
    setCurrentPageFemale(1);
    try {
      localStorage.removeItem("isFiltered");
      localStorage.removeItem("filteredData");
      localStorage.removeItem("searchResults");
      setFilteredData([]);
      setSearchUserlist([]);
      setNoResultsMessage("");
      setShowTabs(true);
      if (!rawUsers.length) {
        queryClient.invalidateQueries({ queryKey: USERS_QUERY_KEY });
      }
    } catch (error) {
      console.error("Clear Filter Error:", error);
    } finally {
      setLoading(false);
    }
  };

const handleAdvanceSearch = (value) => {
  const nameQ = value?.name?.toLowerCase().trim() || "";
  const initiatedQ = value?.initiatedName?.toLowerCase().trim() || "";
  const placeQ = value?.place?.toLowerCase().trim() || "";

  if (!nameQ && !initiatedQ && !placeQ) return;

  setLoading(true);

const matchUser = (user) => {
  const nameMatch = !nameQ ||
    user?.name?.toLowerCase()?.includes(nameQ);
  const initiatedMatch = !initiatedQ ||
    user?.initiatedName?.toLowerCase()?.includes(initiatedQ);
  const placeMatch = !placeQ ||
    user?.currentCity?.toLowerCase()?.includes(placeQ) ||
    user?.birthCity?.toLowerCase()?.includes(placeQ);
  return nameMatch && initiatedMatch && placeMatch;
};


  try {
    let filteredUsers = [];
    if (mainActiveTab === 0) {
      if (activeTab === 0) filteredUsers = allUsers?.filter(matchUser);
      else if (activeTab === 1) filteredUsers = maleList.filter((user) => user?.gender === "male" && matchUser(user));
      else if (activeTab === 2) filteredUsers = femaleList.filter((user) => user?.gender === "female" && matchUser(user));
    } else if (mainActiveTab === 1) {
      if (activeTab === 0) filteredUsers = handleFilterByStatus(allUsers)?.filter(matchUser);
      else if (activeTab === 1) filteredUsers = maleList.filter((user) => user?.gender === "male" && matchUser(user));
      else if (activeTab === 2) filteredUsers = femaleList.filter((user) => user?.gender === "female" && matchUser(user));
    } else if (mainActiveTab === 2) {
      if (activeTab === 0) filteredUsers = handleFilterByRegisteredUsers(allUsers)?.filter(matchUser);
      else if (activeTab === 1) filteredUsers = maleList.filter((user) => user?.gender === "male" && matchUser(user));
      else if (activeTab === 2) filteredUsers = femaleList.filter((user) => user?.gender === "female" && matchUser(user));
    } else if (mainActiveTab === 3) {
      if (activeTab === 0) filteredUsers = handleFilterBySignupUsers(allUsers)?.filter(matchUser);
      else if (activeTab === 1) filteredUsers = maleList.filter((user) => user?.gender === "male" && matchUser(user));
      else if (activeTab === 2) filteredUsers = femaleList.filter((user) => user?.gender === "female" && matchUser(user));
    }

    if (filteredUsers.length > 0) {
      setSearchUserlist(filteredUsers);
      setNoResultsMessage("");
      localStorage.setItem("searchResults", JSON.stringify(filteredUsers));
    } else {
      setNoResultsMessage("No users found matching your criteria.");
    }
  } catch (error) {
  if (error.name !== "AbortError") {
    console.error("Search Error:", error);
  }  } finally {
    setLoading(false);
  }
};

  const handleSearchBar = () => {
    setIsSearchBarVisible(!isSearchBarVisible);
    setSearchUserlist([]);
    setNoResultsMessage("");
    setShowTabs(true);
    setCurrentSearchPage(1);
  };

  const toggleFilter = () => setShowFilter(!showFilter);

  const totalPagesAll = Math.ceil(allUserList.length / itemsPerPage);
  const totalPagesMale = Math.ceil(maleList.length / itemsPerPage);
  const totalPagesFemale = Math.ceil(femaleList.length / itemsPerPage);
  const totalFilterPages = Math.ceil(filteredData.length / itemsPerPage);
  const totalSearchPages = Math.ceil(searchUserList.length / itemsPerPage);

  const currentAllUsers = allUserList.slice(
    (currentPageAll - 1) * itemsPerPage,
    currentPageAll * itemsPerPage,
  );
  const currentMaleUsers = maleList.slice(
    (currentPageMale - 1) * itemsPerPage,
    currentPageMale * itemsPerPage,
  );
  const currentFemaleUsers = femaleList.slice(
    (currentPageFemale - 1) * itemsPerPage,
    currentPageFemale * itemsPerPage,
  );
  const currentFiletrUsers = filteredData.slice(
    (currentFilterPage - 1) * itemsPerPage,
    currentFilterPage * itemsPerPage,
  );
  const currentSearchUsers = searchUserList.slice(
    (currentSearchPage - 1) * itemsPerPage,
    currentSearchPage * itemsPerPage,
  );

  return (
    <div className="mt-7 flex w-full flex-col px-4 md:mt-0">
      <div className="mb-3 h-auto w-full rounded-lg bg-bgWhite p-2 shadow-md">

        {filteredData.length === 0 && searchUserList.length === 0 && (
          <div className="flex flex-col items-center justify-between gap-4 md:flex-row md:gap-0">
            <ul className="flex flex-row self-center sm:self-auto">
              {mainTabList.map((list, index) => (
                <li
                  key={index}
                  className={`font-jost cursor-pointer px-2 py-2 text-center text-[10px] text-textGreen transition-all ms:text-[12px] xxs:text-[14px] 
                    ${initialLoading ? "cursor-not-allowed" : ""}
                    ${mainActiveTab === index ? "border-b-2 border-textYellow font-semibold text-textYellow" : "hover:bg-gray-100 hover:text-textYellow"}`}
                  onClick={() => !initialLoading && handleMainTabClick(index)}
                >
                  {list.name}({list.count})
                </li>
              ))}
            </ul>
            <div
              className={`flex flex-row gap-1 text-[10px] ms:text-[12px] xxs:text-[14px] xl:flex-row ${initialLoading ? "cursor-not-allowed" : ""}`}
            >
              <label htmlFor="sort" className="font-jost text-textGreen">
                Sort by Register Date :
              </label>
              <select
                onChange={(e) => handleSort(e?.target?.value)}
                name="sort"
                id="sort"
                value={sortOrder}
                className="w-[100px] rounded-lg border-[1px] border-gray-500 px-2 outline-none xxs:w-[150px] sm:w-[200px]"
              >
                <option value="last">Last Updated Users</option>
                <option value="desc">Latest Registered Users</option>
                <option value="asc">Oldest Registered Users</option>
              </select>
            </div>
          </div>
        )}

        {showTabs && (
          <div className="font-helvetica flex flex-col items-center gap-2 text-textGreen sm:flex-row sm:justify-between">
            {filteredData.length === 0 && searchUserList.length === 0 ? (
              <ul className="flex border-b border-gray-300 md:flex-row">
                {tabList.map((list, index) => (
                  <li
                    key={index}
                    className={`font-jost cursor-pointer px-4 py-2 text-center text-[10px] text-textGreen transition-all ms:text-[12px] xxs:text-[14px]
                      ${initialLoading ? "cursor-not-allowed" : ""}
                      ${activeTab === index ? "border-b-2 border-textYellow font-semibold text-textYellow" : "hover:bg-gray-100 hover:text-textYellow"}`}
                    onClick={() => !initialLoading && handleTabClick(index)}
                  >
                    {list.name}({list.count})
                  </li>
                ))}
              </ul>
            ) : (
              <>
                {filteredData.length > 0 ? (
                  <div className="mt-4 flex items-center gap-3">
                    <p className="text-md berkshire text-textGreen">
                      Filtered Result Users({" "}
                      {noResultsMessage ? 0 : filteredData.length} )
                    </p>
                    {!noResultsMessage && (
                      <button
    onClick={() => generateFilteredPDF(filteredData)}
    title="Download all filtered users as PDF"
    className="flex items-center gap-1 rounded-md bg-yellow-600 px-3 py-1 text-xs font-semibold text-white shadow transition-all hover:bg-yellow-700"
  >
    <FiDownload size={14} />
    Download PDF
  </button>
                    )}
                  </div>
                ) : (
                  <div className="mt-4">
                    <p className="text-md berkshire text-textGreen">
                      Searched Users( {searchUserList.length} )
                    </p>
                  </div>
                )}
              </>
            )}

            <div
              className={`flex ${isSearchBarVisible ? "flex-col xs:flex-row" : "flex-row"} items-center justify-center gap-2`}
            >
              {isSearchBarVisible && !isFilterApplied && (
                <div className="flex flex-col items-center justify-center gap-1 border-x-gray-400 p-2 xs:flex-row">
                  <AdvanceSearch onSearchValue={handleAdvanceSearch} />
                </div>
              )}
              <div className="flex items-center justify-center">
                {isSearchBarVisible && !isFilterApplied ? (
                  <ImCancelCircle
                    style={{
                      fontSize: "25px",
                      color: "GrayText",
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      handleClearFilter();
                      handleSearchBar();
                    }}
                  />
                ) : (
                  !isFilterApplied &&
                  !initialLoading &&
                  !loading &&
                  !searchUserList.length > 0 && (
                    <IoIosSearch
                      style={{
                        fontSize: "30px",
                        color: "GrayText",
                        cursor: "pointer",
                      }}
                      onClick={() => handleSearchBar()}
                    />
                  )
                )}
              </div>
              <div className="flex flex-row justify-between gap-4 p-1">
                <div className="flex flex-row justify-between gap-4 p-1">
                  {searchUserList.length > 0 && (
                    <button
                      className="font-jost rounded-lg bg-red-600 px-4 py-2 text-xs text-bgWhite xl:text-base"
                      onClick={() => {
                        handleClearFilter();
                        handleSearchBar();
                        setIsSearchBarVisible(false);
                      }}
                    >
                      Clear
                    </button>
                  )}
                </div>
                <div>
                  {!searchUserList.length > 0 && (
                    <div className="flex gap-4">
                      <button
                        className="font-jost rounded-lg bg-textYellow px-4 py-2 text-[12px] text-bgWhite xs:text-[10px] md:text-[12px] xl:text-base"
                        onClick={toggleFilter}
                      >
                        Show Filter
                      </button>
                      <button
                        className="font-jost rounded-lg bg-red-600 px-4 py-2 text-xs text-bgWhite xl:text-base"
                        onClick={handleClearFilter}
                      >
                        Clear Filter
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}

        {initialLoading || isFetching || loading ? (
          <div className="flex h-screen items-center justify-center">
            <Spinner />
          </div>
        ) : (
          <>
            {noResultsMessage ? (
              <div className="mt-4 text-center text-red-600">
                {noResultsMessage}
              </div>
            ) : (
              <>
                {activeTab === 1 && noMaleUsersMessage && (
                  <div className="mt-4 text-center text-red-600">
                    {noMaleUsersMessage}
                  </div>
                )}
                {activeTab === 2 && noFemaleUsersMessage && (
                  <div className="mt-4 text-center text-red-600">
                    {noFemaleUsersMessage}
                  </div>
                )}

                {filteredData.length > 0 || searchUserList.length > 0 ? (
                  <>
                    {filteredData.length > 0 ? (
                      <div className="mt-4">
                        {currentFiletrUsers.map((item, index) => (
                          <ProfileList
                            key={index}
                            role={Role}
                            userData={item}
                          />
                        ))}
                        <Pagination
                          currentPage={currentFilterPage}
                          totalPages={totalFilterPages}
                          handlePageChange={setCurrentFilterPage}
                        />
                      </div>
                    ) : (
                      <div className="mt-4">
                        {currentSearchUsers.map((item, index) => (
                          <ProfileList
                            key={index}
                            role={Role}
                            userData={item}
                          />
                        ))}
                        <Pagination
                          currentPage={currentSearchPage}
                          totalPages={totalSearchPages}
                          handlePageChange={setCurrentSearchPage}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <>
                    {activeTab === 0 &&
                      (allUserList.length > 0 ? (
                        <>
                          {currentAllUsers.map((item, index) => (
                            <ProfileList
                              key={index}
                              role={Role}
                              userData={item}
                            />
                          ))}
                          <Pagination
                            currentPage={currentPageAll}
                            totalPages={totalPagesAll}
                            handlePageChange={setCurrentPageAll}
                          />
                        </>
                      ) : (
                        <div className="flex flex-col items-center justify-center">
                          <p className="text-center">No Users found!</p>
                        </div>
                      ))}
                    {activeTab === 1 &&
                      (maleList.length > 0 ? (
                        <>
                          {currentMaleUsers.map((item, index) => (
                            <ProfileList
                              key={index}
                              role={Role}
                              userData={item}
                            />
                          ))}
                          <Pagination
                            currentPage={currentPageMale}
                            totalPages={totalPagesMale}
                            handlePageChange={setCurrentPageMale}
                          />
                        </>
                      ) : (
                        <div className="flex flex-col items-center justify-center">
                          <p className="text-center">No Male Users found!</p>
                        </div>
                      ))}
                    {activeTab === 2 &&
                      (femaleList.length > 0 ? (
                        <>
                          {currentFemaleUsers.map((item, index) => (
                            <ProfileList
                              key={index}
                              role={Role}
                              userData={item}
                            />
                          ))}
                          <Pagination
                            currentPage={currentPageFemale}
                            totalPages={totalPagesFemale}
                            handlePageChange={setCurrentPageFemale}
                          />
                        </>
                      ) : (
                        <div className="flex flex-col items-center justify-center">
                          <p className="text-center">No female users found!</p>
                        </div>
                      ))}
                  </>
                )}
              </>
            )}
          </>
        )}

        {showFilter && (
          <Filter
            handleShowFilter={toggleFilter}
            onApplyFilters={handleApplyFilters}
          />
        )}
      </div>
      <MessageBar />
    </div>
  );
};

export default Matrimony;
